import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import render from '../ReduxForm/renderField';
import validations from '../ReduxForm/validations';
import validationMessages from '../ReduxForm/messages';

import buttonStyle from '../../styles/base/button.scss'; // eslint-disable-line css-modules/no-unused-class
import s from './SetPasswordForm.scss';

import { messagesChange } from './messages';

const validate = values => {
  const errors = {};
  if (!validations.required(values.currentPassword)) {
    errors.currentPassword = (
      <FormattedMessage {...validationMessages.required} />
    );
  }
  if (!validations.required(values.newPassword)) {
    errors.newPassword = <FormattedMessage {...validationMessages.required} />;
  }
  if (!validations.required(values.passwordControll)) {
    errors.passwordControll = (
      <FormattedMessage {...validationMessages.required} />
    );
  }
  if (!(values.passwordControll === values.newPassword)) {
    errors.passwordControll = (
      <FormattedMessage {...validationMessages.passwordConfirmation} />
    );
  }

  return errors;
};

class ChangePasswordForm extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    errors: PropTypes.arrayOf(PropTypes.string),
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    errors: [],
  };

  render() {
    const { intl, errors, handleSubmit } = this.props;
    return (
      <div className={s.resetPasswordForm}>
        <h1>
          <FormattedMessage {...messagesChange.heading} />
        </h1>
        <span className={s.subline}>
          <FormattedMessage {...messagesChange.info} />
        </span>
        <form className="default-form" onSubmit={handleSubmit}>
          <fieldset>
            <Field
              id="currentPassword"
              name="currentPassword"
              type="password"
              label={intl.formatMessage(messagesChange.currentPassword)}
              component={render.renderInput}
            />
            <Field
              id="newPassword"
              name="newPassword"
              type="password"
              label={intl.formatMessage(messagesChange.newPassword)}
              component={render.renderInput}
            />
            <Field
              id="passwordControll"
              name="passwordControll"
              type="password"
              label={intl.formatMessage(messagesChange.passwordRepeat)}
              component={render.renderInput}
            />
            {errors.length === 0 ? null : (
              <ul style={{ padding: '0', listStyleType: 'none' }}>
                {errors.map(err => (
                  <li key={err} className="validationError">
                    {err}
                  </li>
                ))}
              </ul>
            )}
            <button
              type="submit"
              className={`${buttonStyle['btn-primary']} ${s.button}`}
            >
              <FormattedMessage {...messagesChange.submit} />
            </button>
            <Link
              to="/admin/dashboard"
              className={`${buttonStyle['btn-white-rnd']} ${s.button}`}
            >
              <FormattedMessage {...messagesChange.cancel} />
            </Link>
          </fieldset>
        </form>
      </div>
    );
  }
}

export default withStyles(s)(
  reduxForm({
    form: 'change-password',
    validate,
    pure: false, // this is necessary to trigger form re-renders if the locale changes
  })(injectIntl(ChangePasswordForm)),
);
